import { createCombineMapItem } from '../../../../../reducerRegistry';

import { createReduceObject as createSignInFormReduceObject } from '../../../common/reducers/forms/signInForm';
import signInFormSaga from './sagas/signInFormSaga';

import { createReduceObject as createSignUpFormReduceObject } from '../../../common/reducers/forms/signUpForm';
import signUpFormSaga from './sagas/signUpFormSaga';

import { createReduceObject as createAnketaFormReduceObject } from '../../../common/reducers/forms/anketaForm';
import anketaFormSaga from './sagas/anketaFormSaga';

import { createReduceObject as createAvatarFormReduceObject } from '../../../common/reducers/forms/avatarForm';
import avatarFormSaga from './sagas/avatarFormSaga';

import { createReduceObject as createChangePasswordFormReduceObject } from '../../../common/reducers/forms/changePasswordForm';
import changePasswordFormSaga from './sagas/changePasswordFormSaga';

import { createReduceObject as createProfileFormReduceObject } from '../../../common/reducers/forms/profileForm';
import profileFormSaga from './sagas/profileFormSaga';

import { createReduceObject as createConfirmFormReduceObject } from '../../../common/reducers/forms/confirmForm';
import confirmNewEmailFormSaga from './sagas/confirmNewEmailFormSaga';
import confirmChangeEmailFormSaga from './sagas/confirmChangeEmailFormSaga';

import { createReduceObject as createResendConfirmTokenActionReduceObject } from '../../../common/reducers/forms/resendConfirmTokenAction';
import resendEmailConfirmTokenActionSaga from './sagas/resendEmailConfirmTokenActionSaga';
import resendChangeEmailConfirmTokenActionSaga from './sagas/resendChangeEmailConfirmTokenActionSaga';

import { createReduceObject as createRequestPasswordResetFormReduceObject } from '../../../common/reducers/forms/requestPasswordResetForm';
import requestPasswordResetFormSaga from './sagas/requestPasswordResetFormSaga';

import { createReduceObject as createResetPasswordFormReduceObject } from '../../../common/reducers/forms/resetPasswordForm';
import resetPasswordFormSaga from './sagas/resetPasswordFormSaga';

export default [
  // Forms
  ...createCombineMapItem('signInForm', createSignInFormReduceObject, [
    signInFormSaga
  ]),
  ...createCombineMapItem('signUpForm', createSignUpFormReduceObject, [
    signUpFormSaga
  ]),
  ...createCombineMapItem('anketaForm', createAnketaFormReduceObject, [
    anketaFormSaga
  ]),
  ...createCombineMapItem('avatarForm', createAvatarFormReduceObject, [
    avatarFormSaga
  ]),
  ...createCombineMapItem(
    'changePasswordForm',
    createChangePasswordFormReduceObject,
    [changePasswordFormSaga]
  ),
  ...createCombineMapItem('profileForm', createProfileFormReduceObject, [
    profileFormSaga
  ]),
  ...createCombineMapItem(
    'confirmNewEmailForm',
    createConfirmFormReduceObject,
    [confirmNewEmailFormSaga]
  ),
  ...createCombineMapItem(
    'confirmChangeEmailForm',
    createConfirmFormReduceObject,
    [confirmChangeEmailFormSaga]
  ),
  ...createCombineMapItem(
    'resendEmailConfirmTokenAction',
    createResendConfirmTokenActionReduceObject,
    [resendEmailConfirmTokenActionSaga]
  ),
  ...createCombineMapItem(
    'resendChangeEmailConfirmTokenAction',
    createResendConfirmTokenActionReduceObject,
    [resendChangeEmailConfirmTokenActionSaga]
  ),
  ...createCombineMapItem(
    'requestPasswordResetForm',
    createRequestPasswordResetFormReduceObject,
    [requestPasswordResetFormSaga]
  ),
  ...createCombineMapItem(
    'resetPasswordForm',
    createResetPasswordFormReduceObject,
    [resetPasswordFormSaga]
  )
];



// WEBPACK FOOTER //
// ./src/mt-react-common/modules/users/reducers/static/forms/reducersMap.js